import AuthLayout from '@/components/Layout/AuthLayout'
import { Heading, VStack } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'

const UnauthorizedPage = () => {
  const { t } = useTranslation()

  return (
    <AuthLayout title={'Unauthorized'}>
      <VStack h="100vh" w="100vw" role="alert" justifyContent="center" alignItems="center" spacing="20px">
        <Heading size="lg" color="white">
          {t('UNAUTHORIZE_PAGE_WARNING')}
        </Heading>
      </VStack>
    </AuthLayout>
  )
}

export default UnauthorizedPage
